import MasonItem from "..\\..\\..\\..\\src\\components\\MasonItem";
import React from 'react';
export default {
  MasonItem,
  React
};